<template>
  <div style="padding: 15px;">
    <header style="margin-bottom: 15px;">
      <div style="font-size: 20px">{{ $t('maintain.title') }}</div>
      <a-form-model layout="inline" style="margin: 15px 0;">
        <a-form-model-item :label="$t('maintain.startTime')">
          <a-date-picker allow-clear v-model="startTime" />
        </a-form-model-item>
        <a-form-model-item :label="$t('maintain.endTime')">
          <a-date-picker allow-clear v-model="endTime" />
        </a-form-model-item>
        <a-form-model-item style="float: right;">
          <a-button type="primary" style="margin-right: 10px;" @click="searchMaintainDataList()">{{ $t('buttons.search') }}</a-button>
          <a-button :disabled="isDownloading" type="primary" @click="exportFile">{{ $t('buttons.export') }}</a-button>
        </a-form-model-item>
      </a-form-model>
      <a-progress style="padding-right: 15px;" v-show="isDownloading" :percent="percent" status="active" />
    </header>
    <el-table :data="list" v-loading="tableLoading">
      <el-table-column prop="code" label="整机编号" width="160">
        <template #header>
          <!-- <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.code') }}</div> -->
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.code') }}</div>
          <a-input allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="params.code" />
        </template>
        <template slot-scope="scope">
          <!-- <a @click.stop="gotoDevice(scope.row)"><text-highlight :queries="highLightInfo.code">{{ scope.row.code }}</text-highlight></a> -->
          <text-highlight :queries="highLightInfo.code">{{ scope.row.code }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="设备名称" width="130">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.deviceName') }}</div>
          <a-input allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="params.name" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.name">{{ scope.row.name }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="规格型号" width="120">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.model') }}</div>
          <a-input allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="params.model" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.model">{{ scope.row.model }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="公司名称" width="230">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('customer.company') }}</div>
          <a-input allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="params.company" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.company">{{ scope.row.company }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="归属组织" width="230">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.organization') }}</div>
          <a-input allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="params['salesmen.organizationName']" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo['salesmen.organizationName']">{{ scope.row.salesOrganizations }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="服务组织" width="230">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.sOrganization') }}</div>
          <a-input allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="params['serviceMans.organizationName']" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo['serviceMans.organizationName']">{{ scope.row.serviceOrganizations }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="起始运行时间">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('maintain.startRunningTime') }}</div>
          <!-- <a-select style="width: 50%;" v-model="filters.startRunningTime.req">
            <a-select-option
              v-for="r in reqList"
              :key="r.value"
            >
              {{ r.text }}
            </a-select-option>
          </a-select>
          <a-input style="width: 50%;" allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="filters.startRunningTime.value" /> -->
        </template>
        <template slot-scope="scope">
          {{ scope.row.startRunningTime }}
        </template>
      </el-table-column>
      <el-table-column prop="code" label="截止运行时间">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('maintain.endRunningTime') }}</div>
          <!-- <a-select style="width: 50%;" v-model="filters.endRunningTime.req">
            <a-select-option
              v-for="r in reqList"
              :key="r.value"
            >
              {{ r.text }}
            </a-select-option>
          </a-select>
          <a-input style="width: 50%;" allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="filters.endRunningTime.value" /> -->
        </template>
        <template slot-scope="scope">
          {{ scope.row.endRunningTime }}
        </template>
      </el-table-column>
      <el-table-column prop="code" label="保养时间">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.maintainTime') }}</div>
          <!-- <a-select style="width: 50%;" v-model="filters.maintainTime.req">
            <a-select-option
              v-for="r in reqList"
              :key="r.value"
            >
              {{ r.text }}
            </a-select-option>
          </a-select>
          <a-input style="width: 50%;" allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="filters.maintainTime.value" /> -->
        </template>
        <template slot-scope="scope">
          {{ scope.row.maintainTime }}
        </template>
      </el-table-column>
      <el-table-column prop="code" label="保养设定时间">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.maintainSettingTime') }}</div>
          <!-- <a-select style="width: 50%;" v-model="filters.maintainSettingTime.req">
            <a-select-option
              v-for="r in reqList"
              :key="r.value"
            >
              {{ r.text }}
            </a-select-option>
          </a-select>
          <a-input style="width: 50%;" allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="filters.maintainSettingTime.value" /> -->
        </template>
        <template slot-scope="scope">
          {{ scope.row.maintainSettingTime }}
        </template>
      </el-table-column>
      <el-table-column prop="code" label="设备开机时间" width="120">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.powerOnTime') }}</div>
          <!-- <a-input allow-clear @keyup.enter="searchMaintainDataList" v-model.trim="params.powerOnTime" /> -->
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.powerOnTime">{{ scope.row.powerOnTime }}</text-highlight>
        </template>
      </el-table-column>
    </el-table>
    <a-pagination
      style="float: right; margin-top: 20px; padding-bottom: 20px"
      hideOnSinglePage
      :current="pagination.current"
      :pageSize="pagination.pageSize"
      :total="pagination.total"
      @change="handlePageChange"
    />
  </div>
</template>

<script>
import moment from 'moment'
import TextHighlight from "vue-text-highlight"
import {
  getMaintainDataList,
  getExportUid,
  exportMaintainDataFile
} from '@/api/device'

export default {
  components: { TextHighlight },
  data() {
    return {
      startTime: '',
      endTime: '',
      filters: {
        startRunningTime: {
          req: 'eq',
          value: ''
        },
        endRunningTime: {
          req: 'eq',
          value: ''
        },
        maintainTime: {
          req: 'eq',
          value: ''
        },
        maintainSettingTime: {
          req: 'eq',
          value: ''
        }
      },
      params: {
        code: '',
        name: '',
        model: '',
        powerOnTime: '',
        company: '',
        'salesmen.organizationName': '',
        'serviceMans.organizationName': ''
      },
      highLightInfo: {
        code: '',
        name: '',
        model: '',
        powerOnTime: '',
        company: '',
        'salesmen.organizationName': '',
        'serviceMans.organizationName': ''
      },
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      tableLoading: false,
      reqList: [
        {
          value: 'eq',
          text: '='
        },
        {
          value: 'ge',
          text: '≥'
        },
        {
          value: 'le',
          text: '≤'
        },
        {
          value: 'gt',
          text: '>'
        },
        {
          value: 'lt',
          text: '<'
        }
      ],
      percent: 0,
      isDownloading: false
    }
  },
  created() {
    this.startTime = moment(+new Date).startOf('day')
    this.endTime = moment(+new Date).endOf('day')
  },
  mounted() {
    this.searchMaintainDataList()
  },
  methods: {
    setSearchParams() {
      const params = {
        query: [],
        filter: [],
        sort: []
      }

      for (let key in this.params) {
        this.params[key] = this.params[key].trim()
        if (this.params[key]) {
          params.query.push({
            field: key,
            value: this.params[key]
          })
        }
      }

      for (let key in this.filters) {
        this.filters[key].value = this.filters[key].value.trim()
        if (this.filters[key].value) {
          params.filter.push({
            field: key,
            value: +this.filters[key].value,
            req: this.filters[key].req
          })
        }
      }
      if (params.filter.length) {
        params.filter.push({
          field: 'mode',
          value: 'and'
        })
      }

      return params
    },
    async searchMaintainDataList(e) {
      const params = this.setSearchParams()
      this.tableLoading = true
      if (e) {
        this.pagination.current = 1
      }
      try {
        const { data } = await getMaintainDataList(this.startTime?.format('YYYY-MM-DD HH:mm:ss') || '', this.endTime?.endOf('day').format('YYYY-MM-DD HH:mm:ss') || '', this.pagination.current, this.pagination.pageSize, params)
        this.list = data.records.map(d => {
          let salesOrganizations = [], serviceOrganizations = []
          for (let i = 0; i < d.salesmen.length; i++) {
            if (!salesOrganizations.find(s => s === d.salesmen[i].organizationName)) {
              salesOrganizations.push(d.salesmen[i].organizationName)
            }
          }
          for (let i = 0; i < d.serviceMans.length; i++) {
            if (!serviceOrganizations.find(s => s === d.serviceMans[i].organizationName)) {
              serviceOrganizations.push(d.serviceMans[i].organizationName)
            }
          }
          d.salesOrganizations = salesOrganizations.join(', ')
          d.serviceOrganizations = serviceOrganizations.join(', ')
          return d
        })
        for (let key in this.highLightInfo) {
          this.highLightInfo[key] = this.params[key]
        }
        this.pagination.current = data.current
        this.pagination.total = data.total
      } catch(e) {
        console.log(e)
      } finally {
        this.tableLoading = false
      }
    },
    gotoDevice(device) {
      this.$store.commit('setDeviceInfo', device)
      this.$router.push({ path: '/equipment/list/submit/edit', query: { key: 'monitor' } })
    },
    handlePageChange(p) {
      this.pagination.current = p
      this.searchMaintainDataList()
    },
    async exportFile() {
      this.isDownloading = true
      const { data } = await getExportUid(this.startTime?.format('YYYY-MM-DD HH:mm:ss') || '', this.endTime?.endOf('day').format('YYYY-MM-DD HH:mm:ss') || '', this.setSearchParams())
      
      const source = new EventSource('https://ygk.deman.cn/api/v2/device/maintainData/progress?uid=' + data)
      
      source.onmessage = async e => {
        if (isNaN(+e.data)) {
          source.close()
          const result = await exportMaintainDataFile(data)
          const url = window.URL.createObjectURL(new Blob([result.data], { type: 'application/vnd.ms-excel' }))
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          const name = `${this.startTime?.format('YYYY-MM-DD') || ''} - ${this.endTime?.format('YYYY-MM-DD') || ''} 保养数据`
          link.download = name + '.xlsx'
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
          this.$message.success(this.$t('messages.es'), 1)
          this.isDownloading = false
          this.percent = 0
        } else {
          this.percent = +e.data
        }
      }
      source.onerror = () => {
        this.isDownloading = false
        this.percent = 0
        source.close()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
span.ASC .anticon-caret-up {
  color: #1890ff;
}
span.icons {
  position: absolute;
  right: 24px;
}
span.DESC .anticon-caret-down {
  color: #1890ff;
}
.anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
</style>